module.exports = __webpack_public_path__ + "assets/img/icon-day.9504b6f7.png";